import Vue from "vue";
import moment from "moment";
import numeral from "numeral";
import Expense from "./../../../expense";

Vue.mixin({
	data() {
		return {
			showMenu: true,
			screenWidth: screen.width,
			globalLoading: false,
			currentYear: moment().year(),
			categoryColors: {
				Advertising: "rgba(30, 168, 76, 1)",
				EquipmentRentLease: "rgba(112, 128, 140, 1)",
				Fees: "rgba(238, 75, 52, 1)",
				Flights: "rgba(58, 47, 209, 1)",
				HomeOffice: "rgba(238, 155, 52, 1)",
				Insurance: "rgba(100, 182, 237, 1)",
				MealWithClients: "rgba(56, 127, 229, 1)",
				MealsEntertainment: "rgba(105, 214, 48, 1)",
				None: "rgba(149, 169, 181, 1)",
				OfficeSupplies: "rgba(129, 52, 238, 1)",
				Other: "rgba(211, 41, 106, 1)",
				TrainingEducation: "rgba(226, 55, 190, 1)",
				Transportation: "rgba(70, 75, 79, 1)",
				Vehicle: "rgba(29, 204, 187, 1)"
			},
			projectBackgroundColors: [
				"rgba(71, 175, 106, 0.16)",
				"rgba(68, 176, 191, 0.16)",
				"rgba(102, 111, 137, 0.16)",
				"rgba(66, 134, 222, 0.16)",
				"rgba(57, 72, 188, 0.16)",
				"rgba(135, 52, 190, 0.16)",
				"rgba(213, 79, 69, 0.16)",
				"rgba(240, 150, 55, 0.16)",
				"rgba(161, 94, 67, 0.16)",
				"rgba(78, 78, 78, 0.16)"
			],
			projectColors: [
				"rgba(71, 175, 106, 1)",
				"rgba(68, 176, 191, 1)",
				"rgba(102, 111, 137, 1)",
				"rgba(66, 134, 222, 1)",
				"rgba(57, 72, 188, 1)",
				"rgba(135, 52, 190, 1)",
				"rgba(213, 79, 69, 1)",
				"rgba(240, 150, 55, 1)",
				"rgba(161, 94, 67, 1)",
				"rgba(78, 78, 78, 1)"
			]
		};
	},
	computed: {},
	created: function() {},
	methods: {
		getCategoryIcon(iconName) {
			return Expense.getCategoryIcon(iconName);
		},
		async fetchAttributes(userId) {
			let attributes = await this.$axios
				.get("/attributes?user_id=" + userId, { crossdomain: true })
				.then(({ data }) => {
					return data;
				});
			return attributes;
		},
		findVal(list, name) {
			let naProject = {
				Name: "N/A",
				Color: "rgba(149, 169, 181, 1)",
				ColorTranslucent: "rgba(149, 169, 181, 0.16)"
			};
			var retVal = _.find(list, { Name: name });
			if (!retVal) {
				return naProject;
			}
			return retVal;
		},
		async showDeleteConfirm(type, callback) {
			try {
				let msgConfirm = "Are you sure to delete this " + type + "?";
				const confirm = await this.$bvModal.msgBoxConfirm(msgConfirm, {
					title: "Delete Confirm",
					size: "sm",
					buttonSize: "sm",
					okVariant: "success",
					okTitle: "Yes",
					cancelTitle: "No",
					headerClass: "p-2 border-bottom-0",
					footerClass: "p-2 border-top-0",
					hideHeaderClose: false,
					centered: true
				});
				if (confirm) {
					callback();
				}
			} catch (error) {
				return error;
			}
		},
		toFormatedCurrency(amount, symbol = null) {
			return amount < 0
				? `-${symbol ? symbol : ""}${numeral(Math.abs(amount)).format(
						"0,0.00"
				  )}`
				: `${symbol ? symbol : ""}${numeral(amount).format("0,0.00")}`;
		}
	}
});
